import React from 'react'
import { Link } from 'react-router-dom';
import { formatDate } from '../../helper/formatDate';

export default function SeasonCard({ show, translate }) {
    return <Link to={`/showDetails?id=${show?.id}`} className="seasonCard bg-white shadow px-3 mt-4 position-relative" style={{aspectRatio:'3/4'}}>
        <div className="seasoncardImageContainer">
            <img src={show.showImage} alt="ChangeMe" onError={(e) => (e.target.style.display = 'none')} />
        </div>
        <div className="seasonPostBody">
            <div className="flagimgandcalandericon">
                <img src={show.flag} alt="ChangeMe" />

                <i className="fa fa-calendar iconRed"></i>
            </div>
            <div className="seasonspacer"></div>
            <div className="seasonbody">
                <div className="seasonTitle roboto-bold">
                    {show.name}
                </div>
                <div className="seasonAddress roboto-bold">
                    {show.address}
                </div>
                <div className="seasonDate roboto-medium">
                    {formatDate(show.date)}
                </div>
            </div>
            {show?.registrationOpen &&
                <div className='text-center text-white  mx-2 isOpendNow position-absolute' style={{ maxHeight: 62 }}>{translate('web.participateNow', 'Participate Now')}</div>}
        </div>
    </Link>
        ;
}

